//
// Segment analytics link tracking that includes experiment data.
// The Segment implementation allows a single element or an Array to be passed
// in, so we're keeping this as close as possible to this.
// See: https://segment.com/docs/sources/website/analytics.js/#track-link
// - https://github.com/segmentio/analytics.js/blob/a111102f50118c92d0f5034b71cad8cfb44c3592/analytics.js#L483-L522
// - https://github.com/DefinitelyTyped/DefinitelyTyped/blob/92434b8642aeff543ca3736ae9ef93aa7d93b764/types/segment-analytics/index.d.ts#L150-L156

import { getLinkTargetPath, getLinkTargetUrl } from '../dom';

export default function trackLink(
    trackable: Element[] | Element | NodeListOf<Element> | null,
    event: string | { (elm: Element): string },
    params: Object | { (elm: Element): Object } = {}
): void {
    if (!trackable) return;

    if (trackable instanceof Array) {
        trackable.forEach(el => setupTrackLink(el, event, params));

        return;
    } else if (trackable instanceof NodeList) {
        for (let i = 0; i < trackable.length; i++) {
            setupTrackLink(trackable[i], event, params);
        }

        return;
    } else {
        setupTrackLink(trackable, event, params);

        return;
    }
}
function setupTrackLink(
    element: Element,
    event: string | { (elm: Element): string },
    params?: Object | { (elm: Element): Object }
): void {
    const trackParams = window.trackParams || {};

    params = {
        url: window.location.href,
        target_path: getLinkTargetPath(element),
        target_url: getLinkTargetUrl(element, window.location),
        ...trackParams,
        ...params,
    };

    if (__DEV__) {
        element.addEventListener('click', () => {
            console.info('Track link: "%s": %o', event, params); // eslint-disable-line no-console
        });
    }

    if (window.analytics) {
        window.analytics.trackLink(element, event, params);
    }
}
